import { createContext } from 'react'

const AuthSupplierContext = createContext()

export default AuthSupplierContext
